import { useCallback, useState } from 'react';
import { useLayout } from '../contexts/layout-context';
import { useWindowResize } from './useWindowResize';

export const useContainerDimensions = () => {
    const [containerDimensions, setContainerDimensions] = useState({ width: 0, height: 0 });
    const { totalNavbarHeight } = useLayout();

    const handleWindowResize = useCallback(() => {
        setContainerDimensions({
            height: window.innerHeight - (totalNavbarHeight || 0),
            width: window.innerWidth,
        });
    }, [setContainerDimensions, totalNavbarHeight]);

    useWindowResize(handleWindowResize, true);

    return containerDimensions;
};
